/* ============================================================
   custom-cart.js - Carrito lateral

   Seis cosas:
     1. La cuenta atras de la banda rosa ("tu pedido esta
        reservado durante MM:SS"). Arranca la primera vez que se
        abre el carrito en la pestana y sigue donde iba, no se
        reinicia cada vez que Dawn repinta el carrito.
     2. Las flechas del carrusel DESCUBRE MAS.
     3. Anadir desde DESCUBRE MAS y el interruptor de proteccion
        de envio, los dos por /cart/add.js y /cart/change.js.
     4. Un parche a resetQuantityInput de Dawn (ver abajo).
     5. Mantener a raya la clase is-empty de <cart-drawer>.
     6. Quitar el extra suelto cuando ya no queda ninguna prenda.

   OJO 1: Dawn reemplaza el interior del carrito con HTML nuevo
   cada vez que cambia algo, asi que aqui no se guardan
   referencias a nodos: todo va por delegacion de eventos en
   document, y un MutationObserver vuelve a enganchar la cuenta
   atras cuando aparece un <span> nuevo.

   OJO 2: ese observador mira el mismo trozo de DOM donde la
   cuenta atras escribe cada segundo. Si reaccionara a su propia
   escritura se realimentaria una vez por segundo, asi que la
   cuenta atras escribe con nodeValue (no cambia la lista de
   hijos) y solo se reengancha cuando el nodo del contador es
   OTRO distinto del que ya estaba pintando.

   OJO 3: la cuenta atras nunca se queda en 00:00. Un contador
   parado en cero canta que es de mentira y encima le dice al
   cliente que su reserva ya ha caducado. Al llegar a cero se
   abre un plazo nuevo y vuelve a empezar.

   OJO 4: la clase is-empty de <cart-drawer> la pone y la quita
   Dawn, pero solo por SUS caminos (anadir desde la ficha, tocar
   cantidades, papelera). Si se anade algo por otro lado la clase
   se queda pegada y el carrito lleno sigue vestido de vacio (se
   perdia la banda rosa). Aqui se vuelve a calcular mirando lo
   que hay pintado de verdad, cada vez que el carrito cambia.

   OJO 5: la proteccion de envio no sale en la lista de lineas,
   solo como interruptor. Si el cliente la enciende y luego quita
   todas las prendas, quedaria un carrito "vacio" que en realidad
   cobra 99 pesos invisibles. Cuando pasa eso el carrito pinta
   data-jc-drop-key con la linea del extra y aqui se quita sola.
   ============================================================ */

(function () {
  'use strict';

  var KEY = 'jcart-deadline';

  /* ---------- 0. Parche a cart.js ----------
     Cuando cart.js considera invalida una cantidad llama a
     resetQuantityInput(id), que busca '#Quantity-' + id. Ese id
     solo existe en la PAGINA del carrito; en el carrito lateral
     los campos se llaman 'Drawer-quantity-N'. Resultado: null y
     TypeError, y el carrito se queda a medias con el numero mal
     y sin actualizar. Aqui se busca en los dos sitios y, si no
     hay campo, no se revienta. */

  function patchResetQuantityInput() {
    ['cart-items', 'cart-drawer-items'].forEach(function (tag) {
      if (!window.customElements) return;

      window.customElements.whenDefined(tag).then(function (ctor) {
        if (!ctor || !ctor.prototype || ctor.prototype.__jcPatched) return;
        ctor.prototype.__jcPatched = true;

        ctor.prototype.resetQuantityInput = function (id) {
          var input =
            this.querySelector('#Quantity-' + id) ||
            this.querySelector('#Drawer-quantity-' + id) ||
            this.querySelector('[data-index="' + id + '"].quantity__input');

          if (input) input.value = input.getAttribute('value');
          this.isEnterPressed = false;
        };
      }).catch(function () {
        /* el elemento no existe en esta plantilla */
      });
    });
  }

  /* ---------- 1. Cuenta atras ---------- */

  function saveDeadline(minutes) {
    var next = Date.now() + minutes * 60 * 1000;
    try {
      window.sessionStorage.setItem(KEY, String(next));
    } catch (e) {
      /* navegacion privada: la cuenta atras vive solo en memoria */
    }
    return next;
  }

  function deadlineFor(minutes) {
    var saved = null;
    try {
      saved = window.sessionStorage.getItem(KEY);
    } catch (e) {
      saved = null;
    }

    if (saved && Number(saved) > Date.now()) return Number(saved);
    return saveDeadline(minutes);
  }

  function paint(el, deadline) {
    var left = Math.max(0, deadline - Date.now());
    var total = Math.floor(left / 1000);
    var mm = Math.floor(total / 60);
    var ss = total % 60;
    var text = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;

    /* nodeValue en vez de textContent: cambia el texto sin
       reemplazar el nodo, asi el observador no se entera. */
    if (el.firstChild && el.firstChild.nodeType === 3) {
      el.firstChild.nodeValue = text;
    } else {
      el.textContent = text;
    }
  }

  var timerId = null;
  var timerEl = null;
  var timerDeadline = 0;
  var timerMinutes = 10;

  function stopTimer() {
    if (timerId) window.clearInterval(timerId);
    timerId = null;
    timerEl = null;
  }

  function tick() {
    if (!timerEl || !timerEl.isConnected) {
      stopTimer();
      return;
    }

    /* Se acabo el plazo: se abre otro en vez de dejar un 00:00
       colgado. */
    if (Date.now() >= timerDeadline) timerDeadline = saveDeadline(timerMinutes);

    paint(timerEl, timerDeadline);
  }

  function startTimer() {
    var el = document.querySelector('[data-jc-timer]');

    if (!el) {
      stopTimer();
      return;
    }

    /* Mismo nodo que ya estabamos pintando: no hay nada que hacer. */
    if (el === timerEl && timerId) return;

    timerEl = el;
    timerMinutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    timerDeadline = deadlineFor(timerMinutes);

    if (timerId) window.clearInterval(timerId);
    tick();
    timerId = window.setInterval(tick, 1000);
  }

  /* ---------- 2. Carrusel ---------- */

  function step(track, dir) {
    var card = track.querySelector('.jcart__rec');
    var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  /* ---------- 3. Anadir / quitar ---------- */

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  /* La verdad es lo que hay pintado: si esta el aviso de carrito
     vacio, esta vacio; si no, no. */
  function syncEmptyClass() {
    var d = drawer();
    if (!d) return;
    d.classList.toggle('is-empty', !!d.querySelector('.jcart__empty'));
  }

  function sectionsToRender() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function refresh(json) {
    var d = drawer();
    if (d && typeof d.renderContents === 'function') {
      d.renderContents(json);
      syncEmptyClass();
    } else {
      window.location.reload();
    }
  }

  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function post(url, body, button) {
    if (button) button.disabled = true;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        refresh(json);
      })
      .catch(function () {
        if (button) button.disabled = false;
      });
  }

  function addVariant(id, button) {
    if (!id) return;
    return post(
      root() + 'cart/add.js',
      { items: [{ id: Number(id), quantity: 1 }], sections: sectionsToRender() },
      button
    );
  }

  function changeLine(key, quantity, button) {
    return post(
      root() + 'cart/change.js',
      { id: key, quantity: quantity, sections: sectionsToRender() },
      button
    );
  }

  /* ---------- 4. Extra huerfano ----------
     El carrito se da por vacio cuando no queda ninguna prenda. Si
     ademas habia proteccion de envio encendida, esa linea seguiria
     cobrandose sin verse: se quita. */

  var dropping = false;

  function dropOrphanExtras() {
    if (dropping) return;

    var el = document.querySelector('[data-jc-drop-key]');
    if (!el) return;

    var key = el.getAttribute('data-jc-drop-key');
    if (!key) return;

    dropping = true;
    el.removeAttribute('data-jc-drop-key');

    var done = function () {
      dropping = false;
    };

    var p = changeLine(key, 0);
    if (p && p.then) {
      p.then(done, done);
    } else {
      done();
    }
  }

  /* ---------- Enganches ---------- */

  document.addEventListener('click', function (event) {
    /* El destino puede no ser un Element (por ejemplo document),
       y entonces no tiene closest. Sin esta guarda, un clic en el
       sitio equivocado rompe el resto de manejadores de la pagina. */
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var prev = target.closest('[data-jc-prev]');
    var next = target.closest('[data-jc-next]');
    if (prev || next) {
      var viewport = (prev || next).closest('.jcart__more-viewport');
      var track = viewport && viewport.querySelector('[data-jc-track]');
      if (track) step(track, prev ? -1 : 1);
      return;
    }

    var add = target.closest('[data-jc-add]');
    if (add) {
      var card = add.closest('.jcart__rec');
      var picker = card && card.querySelector('[data-jc-variant]');
      if (picker && picker.value) addVariant(picker.value, add);
      return;
    }

    var prot = target.closest('[data-jc-protect]');
    if (prot) {
      var key = prot.getAttribute('data-key');
      if (prot.classList.contains('is-on') && key) {
        changeLine(key, 0, prot);
      } else {
        addVariant(prot.getAttribute('data-variant'), prot);
      }
    }
  });

  function watch() {
    patchResetQuantityInput();
    syncEmptyClass();
    dropOrphanExtras();
    startTimer();

    var host = document.getElementById('CartDrawer');
    if (!host || host.dataset.jcWatched === 'true') return;
    host.dataset.jcWatched = 'true';

    /* Solo childList/subtree: los atributos no se miran, asi que
       cambiar la clase de <cart-drawer> aqui dentro no vuelve a
       disparar el observador. */
    new MutationObserver(function () {
      syncEmptyClass();
      dropOrphanExtras();
      startTimer();
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
